import React from "react";
import { useRazorpay } from "../../../../context/RazorpayContext";

const AddonPreviewModal = ({ accountType, setShowPage, onCancelPaymentNavigationUrl }) => {

  const {
    addonInvoicePreviewData,
    handleAddOnSellerAccount,
    onCloseAddOnInvoicePreview
  } = useRazorpay();

  if (!addonInvoicePreviewData?.isOpenModal) return null;

  // const packangeName = addonInvoicePreviewData?.previewData?.to_package;
  const planPrice = addonInvoicePreviewData?.previewData?.amount;
  const billingAmount = `${addonInvoicePreviewData?.previewData?.amount} ${addonInvoicePreviewData?.previewData?.currency || 'INR'}`

  const formatedData = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date)) return ''; // Handle invalid date

    const day = date.getDate();
    const year = date.getFullYear();

    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const month = monthNames[date.getMonth()];

    return `${day} ${month} ${year}`;
  };

  const handleSubmitArgument = () => {
    if (accountType === 'amazonAds') {
      return { type: 'amazonAds', action: setShowPage }
    }
    return null
  }


  return (
    <>
      <div
        className="modal d-flex align-items-center justify-content-center"
        style={{
          display: "flex",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1052,

        }}
      >
        <div
          className="modal-dialog animate__animated animate__fadeInDown"
          style={{
            maxWidth: "600px",
            width: "100%",
            margin: "0 auto",
          }}
        >
          <div
            className="modal-content border-0 rounded-4 shadow-lg"
            style={{
              background: "linear-gradient(145deg, #ffffff, #f9fafb)",
              overflow: "hidden",
            }}
          >
            {/* Header */}
            <div className="modal-header border-0">
              <h4
                className="modal-title fw-bold text-dark"
                style={{ fontSize: "1.2rem" }}
              >
                Your Subscription Summary
              </h4>
              {accountType === 'marketPlaceAccount' &&
                <div className="modal-close-btn">
                  <button type="button" className="btn-close" onClick={onCloseAddOnInvoicePreview}></button>
                </div>
              }
            </div>

            {/* Body */}
            <div className="modal-body p-3 p-md-4">
              <div className="p-3 rounded-4 shadow-sm bg-white">
                {/* <div className="d-flex flex-column flex-sm-row align-items-start align-items-sm-center justify-content-between mb-3 gap-2"> */}
                  {/* <h5 className="fw-bold text-primary mb-0 d-flex align-items-center flex-wrap"> */}
                    {/* <i className="bi bi-credit-card text-warning me-2"></i>
                    {packangeName} */}
                  {/* </h5> */}
                  {/* <span
                    className="px-3 py-1 rounded-pill text-white plan-detail-card-btn"
                    style={{
                      fontSize: "0.8rem",
                      fontWeight: "600",
                      whiteSpace: "nowrap",
                    }}
                  >
                    🔄 AutoPay Enabled
                  </span> */}
                {/* </div> */}

                {/* Price */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                  <span className="fw-semibold text-secondary d-flex align-items-center">
                    <i className="bi bi-tag text-success me-2"></i>
                    Package Price
                  </span>
                  <span className="fw-bold text-dark">
                    {planPrice} {addonInvoicePreviewData?.previewData?.currency}
                  </span>
                </div>

                {/* Billing Dates */}
                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="fw-semibold text-secondary d-flex align-items-center">
                    <i className="bi bi-calendar3 text-info me-2"></i>
                    Billing Start At
                  </span>
                  <span className="fw-medium text-end">
                    {formatedData(addonInvoicePreviewData?.previewData?.billing_start_at)}
                  </span>
                </div>

                <div className="d-flex justify-content-between align-items-center mb-2">
                  <span className="fw-semibold text-secondary d-flex align-items-center">
                    {/* <Calendar size={16} className="me-2 text-danger" /> */}
                    <i className="bi bi-calendar3 text-secondary me-2"></i>
                    Billing End At
                  </span>
                  <span className="fw-medium text-end">
                    {formatedData(addonInvoicePreviewData?.previewData?.billing_end_at)}
                  </span>
                </div>

                <hr />

                {/* Total */}
                <div className="d-flex justify-content-between fs-5 fw-bold text-dark">
                  <span>Billing Amount</span>
                  <span className="text-success">
                    {billingAmount}
                  </span>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div
              className="border-0 d-flex flex-column flex-sm-row justify-content-between px-3 px-md-4 pb-4"
              style={{ gap: "10px" }}
            >
              <div className="col-md-6 col-12">
              <button className="btn btn-light w-100 w-sm-auto px-4 py-2 rounded-3 border shadow-sm" disabled={addonInvoicePreviewData?.isLoading} onClick={(e) => onCloseAddOnInvoicePreview(e, onCancelPaymentNavigationUrl)}>
                Cancel
              </button>
              </div>
              <div className="col-md-6 col-12">
              <button
                className="btn plan-detail-card-btn w-100 w-sm-auto px-4 py-2 fw-semibold rounded-3 shadow"
                onClick={(e) => handleAddOnSellerAccount(e, addonInvoicePreviewData?.previewData?.subscribable_id || addonInvoicePreviewData?.previewData?.marketplace_account_id, handleSubmitArgument())}
                disabled={addonInvoicePreviewData?.isLoading}
              >
                {addonInvoicePreviewData?.isLoading ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm me-2"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    Loading...
                  </>
                ) : <> 🚀 Continue to Payment </>
                }
              </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddonPreviewModal;